import React, {FC} from "react";
import {makeStyles} from "@material-ui/core";
import {px} from "Configs/theme";
import FadeInBox from "Components/Layout/FadeInBox";
import {CheckCircle} from "@material-ui/icons";

const SuccessIndicator: FC = () => {
    const classes = useStyles();

    return (
        <FadeInBox className={classes.box} delay={800} delayIndex={1}>
            <CheckCircle color="primary" fontSize="large"/>
        </FadeInBox>
    );
};

export default SuccessIndicator;

const useStyles = makeStyles({
    box: {
        padding: px.m,
        display: "flex",
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
    },
});
